function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.375,1.25h-1.123c0.029-0.093,0.059-0.186,0.059-0.289C28.311,0.43,27.879,0,27.348,0s-0.961,0.431-0.961,0.961 c0,0.103,0.028,0.196,0.059,0.289h-3.68c0.029-0.093,0.059-0.186,0.059-0.289C22.824,0.43,22.393,0,21.861,0 C21.332,0,20.9,0.431,20.9,0.961c0,0.103,0.029,0.196,0.06,0.289h-3.681c0.029-0.093,0.058-0.186,0.058-0.289 C17.337,0.43,16.907,0,16.376,0c-0.531,0-0.961,0.431-0.961,0.961c0,0.103,0.028,0.196,0.058,0.289h-3.681 c0.029-0.093,0.059-0.186,0.059-0.289C11.851,0.43,11.42,0,10.89,0c-0.531,0-0.962,0.431-0.962,0.961 c0,0.103,0.028,0.196,0.058,0.289h-3.68c0.03-0.093,0.059-0.186,0.059-0.289C6.365,0.43,5.935,0,5.404,0 C4.873,0,4.442,0.431,4.442,0.961c0,0.103,0.028,0.196,0.058,0.289H3.375c-1.518,0-2.75,1.233-2.75,2.75v26 c0,1.518,1.232,2.75,2.75,2.75H26.27l5.855-5.855V4C32.125,2.484,30.893,1.25,29.375,1.25z M30.625,26.273l-0.311,0.311h-2.355 c-1.102,0-2,0.9-2,2v2.355l-0.311,0.311H3.375c-0.689,0-1.25-0.561-1.25-1.25V5h28.5V26.273z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.892,
  y: 7.535,
  width: 3.536,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.607,
  y: 7.535,
  width: 3.536,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.322,
  y: 7.535,
  width: 3.535,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.037,
  y: 7.535,
  width: 3.537,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.176,
  y: 12.25,
  width: 3.537,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.892,
  y: 12.25,
  width: 3.536,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.607,
  y: 12.25,
  width: 3.536,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.322,
  y: 12.25,
  width: 3.535,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.037,
  y: 12.25,
  width: 3.537,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.176,
  y: 16.965,
  width: 3.537,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.892,
  y: 16.965,
  width: 3.536,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.607,
  y: 16.965,
  width: 3.536,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.322,
  y: 16.965,
  width: 3.535,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.037,
  y: 16.965,
  width: 3.537,
  height: 3.537
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.176,
  y: 21.68,
  width: 3.537,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.892,
  y: 21.68,
  width: 3.536,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.607,
  y: 21.68,
  width: 3.536,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.322,
  y: 21.68,
  width: 3.535,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.037,
  y: 21.68,
  width: 3.537,
  height: 3.536
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.176,
  y: 26.984,
  width: 8.251,
  height: 1.768
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_42364",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.963ddad0.svg";
export { ForwardRef as ReactComponent };